import { withJsonFormsControlProps } from "@jsonforms/react";
import TextInputFieldHexaColor from "./TextInputFieldHexaColor";

const TextInputHexaColorComponent = (props) => {
  const {
    handleChange,
    label,
    data,
    path,
    errors,
    schema,
    uischema,
    required,
    enabled,
  } = props;
  return (
    <TextInputFieldHexaColor
      value={data}
      label={label}
      updateValue={(newVal) => handleChange(path, newVal)}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
      disabled={!enabled}
    />
  );
};

export const TextInputHexaColorControl = withJsonFormsControlProps(
  TextInputHexaColorComponent
);
